<template>
  <div class="content">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Lista</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button @click="abrirModalNovoProduto" size="sm" type="neutral">Novo</base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">Lista de Produtos</h3>
            <p class="text-sm mb-0">Lista de produtos cadastrados</p>
          </template>
          <div>
            <b-col
              cols="12"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <data-table
                v-if="!loading"
                :columns="columns"
                :map="map"
                :data="data"
                label="produtos"
                @on-row-click="setProduto"
              >
              </data-table>
              <product-details :product="product" :map="map" @product-detail-dismiss="product = null" />
            </b-col>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./../Tables/PaginatedTables/clientPaginationMixin";
import bocapioCakeService from "./../../services/cakephp/index";
//IMPORTS DE PRODUTOS
import DataTable from "@/components/DataTable/DataTable";
import DataTableHelper from "../../providers/DataTable";
import ProductDetails from "@/components/ProductDetails/ProductDetails";
import { mapGetters } from "vuex";
//
var axios = require("axios");

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DataTable,
    ProductDetails,
  },
  data() {
    return {
      loading: true,
      columns: [],
      data: [],
      map: null,
      product: null, //PRODUTO CLICADO PELA ROW
    };
  },
  mounted() {
    this.getProducts();
  },
  computed: {
    ...mapGetters([
      "params"
    ]),
  },
  methods: {
    fetchProducts() {
      bocapioCakeService
        .getAjax('products', 'list', '','GET','jsonp')
        .then((rsp) => {
          this.data = rsp.list;
          this.loading = false;
        })
    },
    setProduto(data) {
      this.product = data;
    },
    getColumns() {
      //PEGAR TRS DE PRODUTOS
      this.columns = DataTableHelper.gerarColunas("products", this.map, this.params);
    },
    async getMap() {
      return axios.get(`${process.env.VUE_APP_API_CAKE_URL}products/json/map`);
    },
    getProducts() {
      this.getMap()
        .then((response) => {
          const map = response.data.map;
          this.map = map;
          this.getColumns();
          this.fetchProducts();
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    abrirModalNovoProduto() {
      this.$root.$emit("modal-product-novo");
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
